import { render, staticRenderFns } from "./blocks-field.vue?vue&type=template&id=6790fe53&scoped=true&"
import script from "./blocks-field.vue?vue&type=script&lang=js&"
export * from "./blocks-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6790fe53",
  null
  
)

export default component.exports